import React, { FC, ReactElement, useContext } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Box, BoxProps, Page, PageContent } from 'grommet';
import { ThemeModeContext, ThemeProvider } from '@pentester.com/grommet-theme';
import { BaseComponentProps } from '@/types';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Sumo } from '@/components/Sumo';
import '@/styles/style.css';

// Constraining box might need to be removed and width constraint forced on all child components
export const Layout: FC<BaseComponentProps & BoxProps> = ({
  children,
  ...rest
}): ReactElement => (
  <ThemeProvider>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}
      scriptProps={{
        async: true,
        defer: true,
      }}
      container={{
        element: `recaptcha`,
        parameters: {
          badge: `inline`,
          theme: useContext(ThemeModeContext).mode as 'light' | 'dark',
        },
      }}
    >
      <Page>
        <Sumo />
        <Box {...rest}>
          <PageContent style={{ minWidth: `320px` }}>
            <Header />
          </PageContent>
          <PageContent style={{ minWidth: `320px` }}>{children}</PageContent>
        </Box>
        <PageContent style={{ minWidth: `320px` }}>
          <Footer />
        </PageContent>
      </Page>
    </GoogleReCaptchaProvider>
  </ThemeProvider>
);
